import React, { memo, ReactElement } from 'react'
import { Translate } from 'react-localize-redux'
import { Button, ButtonType } from '@digicert/dcone-common-ui'
import { FormMode } from '../../interfaces'
import { PropsFormsActionsButtons } from './forms-actions-buttons.interfaces'

const Buttons = (props: PropsFormsActionsButtons): ReactElement => {
  if(props.editingDisabled) {
    return <></>
  }
  else return (
    <div className='form-buttons-wrap'>
      {!props.skipCancel && (
        <Button
          id='cancel_btn'
          buttonType={ButtonType.SECONDARY}
          onClick={(e) => {
            e.preventDefault()
            if(props.onCancel) {
              props.onCancel()
            }
          }}
        >
          <Translate id='common.form.buttons.cancelBtn'/>
        </Button>
      )}

      {props.currentStep !== 0 && props.goBack &&(
        <Button
          id='back_btn'
          buttonType={ButtonType.SECONDARY}
          onClick={(e) => {
            e.preventDefault()
            if(props.goBack) {
              props.goBack()
            }
          }}
        >
          <Translate id='common.form.buttons.backBtn'/>
        </Button>)
      }

      <Button
        id='save_or_update_btn'
        buttonType={ButtonType.PRIMARY}
        disabled={props.isDisabled || props.invalid}
      >
        <span>
          {props.mode === FormMode.create
            ? (
              <Translate
                id={
                  props.currentStep >= props.lastStep
                    ? props.submitBtnLabel
                      ? props.submitBtnLabel
                      : 'common.form.buttons.createBtn'
                    : 'common.form.buttons.nextBtn'
                }
              />
            ) : (
              <Translate
                id={
                  props.currentStep >= props.lastStep
                    ? props.submitBtnLabel
                      ? props.submitBtnLabel
                      : props.featureEnabled ? 'common.form.buttons.updatePermissionsBtn' : 'common.form.buttons.updateBtn'
                    : 'common.form.buttons.nextBtn'
                }
              />
            )
          }
        </span>
      </Button>
    </div>
  )
}

export default memo(Buttons)
